import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SEO from '../../components/feature/SEO';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import InspeccionGratisSection from './components/InspeccionGratisSection';
import StatsAboutSection from './components/StatsAboutSection';
import WhyUsSection from './components/WhyUsSection';
import SocialSection from './components/SocialSection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'AutoRepair',
    name: 'Taller Mecánico Kevin Alberto',
    description:
      'Taller mecánico en Ronda, Málaga con más de 25 años de experiencia. Mecánica general, diagnosis electrónica, chapa y pintura. Presupuesto sin compromiso.',
    url: siteUrl,
    telephone: '+34666365922',
    email: 'tallerkevinalberto@gmail.com',
    image: 'https://public.readdy.ai/ai/img_res/edited_cf5f49ab1140a20ec7a1c97d7d794c41_30d692f2.jpg',
    priceRange: '€€',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'C. Guadalimar, 7',
      addressLocality: 'Ronda',
      postalCode: '29400',
      addressRegion: 'Málaga',
      addressCountry: 'ES',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '36.7450',
      longitude: '-5.1679',
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '07:00',
        closes: '15:00',
      },
    ],
    sameAs: ['https://www.facebook.com/taller.mecanico.Kevin'],
    hasMap: 'https://maps.google.com/?q=C.+Guadalimar,+7,+29400+Ronda,+Malaga',
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '5',
      reviewCount: '5000',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Taller Mecánico Kevin Alberto',
    url: siteUrl,
    description:
      'Taller mecánico en Ronda, Málaga. Mecánica, diagnosis electrónica, chapa y pintura.',
    inLanguage: 'es',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Inicio – Taller Mecánico Kevin Alberto Ronda Málaga',
    url: siteUrl,
    description:
      'Taller mecánico en Ronda, Málaga con más de 25 años de experiencia. Mecánica general, diagnosis electrónica, chapa y pintura. Presupuesto sin compromiso.',
    inLanguage: 'es',
    isPartOf: { '@type': 'WebSite', url: siteUrl },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Inicio', item: siteUrl },
      ],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '¿Dónde está el Taller Mecánico Kevin Alberto en Ronda?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Estamos en C. Guadalimar, 7, 29400 Ronda, Málaga. Puedes llamarnos al +34 666 36 59 22 para más información.',
        },
      },
      {
        '@type': 'Question',
        name: '¿Cuál es el horario del taller mecánico en Ronda?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Abrimos de lunes a viernes de 07:00 a 15:00 h. Los sábados y domingos permanecemos cerrados.',
        },
      },
      {
        '@type': 'Question',
        name: '¿Ofrecéis presupuesto sin compromiso en Ronda?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Sí, en Taller Mecánico Kevin Alberto siempre ofrecemos presupuesto sin compromiso antes de iniciar cualquier reparación. Puedes pedirlo por teléfono, WhatsApp o rellenando nuestro formulario online.',
        },
      },
      {
        '@type': 'Question',
        name: '¿Qué servicios ofrece el taller mecánico en Ronda, Málaga?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Ofrecemos mecánica general, diagnóstico electrónico, frenos y suspensión, chapa y pintura, climatización, cambio de aceite y revisiones periódicas para todo tipo de vehículos.',
        },
      },
    ],
  },
];

const HomePage = () => (
  <div className="flex flex-col min-h-screen bg-black">
    <SEO
      title="Taller Mecánico Kevin Alberto Ronda Málaga"
      description="Taller mecánico en Ronda, Málaga con más de 25 años de experiencia. Mecánica general, diagnosis electrónica, chapa y pintura. Presupuesto sin compromiso. Llama: +34 666 36 59 22."
      keywords="taller mecánico Ronda, mecánico Ronda Málaga, diagnosis electrónica Ronda, chapa pintura Ronda"
      canonical="/"
      jsonLd={homeJsonLd}
    />
    <Navbar />
    <main className="flex-grow">
      <HeroSection />
      <ServicesSection />
      <InspeccionGratisSection />
      <StatsAboutSection />
      <WhyUsSection />
      <SocialSection />
    </main>
    <Footer />
    <WhatsAppButton />
  </div>
);

export default HomePage;
